import { apiResponse } from "@/shared/api/client";

/** 标记配置向导已完成（写入 SetupWizardState） */
export function completeSetupWizard() {
  return apiResponse("/api/v1/system/setting/SetupWizardState", {
    method: "POST",
    body: true,
  });
}
